<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, computed } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import CampoTextoBase from '@/components/v2/base/CampoTextoBase/CampoTextoBase.vue';
import CampoAutocompleteBase from '@/components/v2/base/CampoAutocompleteBase/CampoAutocompleteBase.vue';
import CampoTextareaBase from '@/components/v2/base/CampoTextareaBase/CampoTextareaBase.vue';
import CampoDataBase from '@/components/v2/base/CampoDataBase/CampoDataBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    aprovacao: {
        type: Object,
        default: () => ({})
    },
    aprovadorIsAdmin: {
        type: Boolean,
        default: false
    },
    aprovacoesDoTipo: {
        type: Array,
        default: () => ([])
    },
    aprovacaoTipo: {
        type: String,
        default: 'Nenhum'
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'update:alteraAprovacao',
    'update:selecionaAprovacao'
]);

/*==================================================================*/
/*================== ALTERA APROVACAO ==============================*/
/*==================================================================*/

const alteraAprovacao = (update = {}) => {

    emits('update:alteraAprovacao', update);

};

/*==================================================================*/
/*================== SELECIONA APROVACAO ==========================*/
/*==================================================================*/

const selecionaAprovacao = (dado = {}) => {

    emits('update:selecionaAprovacao', dado);

};

/*==================================================================*/
/*================== DISABLED APROVADOR ============================*/
/*==================================================================*/

const disabledAprovador = computed(() => {

    if(props.disabled){
        return true;
    }

    if(props.aprovadorIsAdmin === false){
        return true;
    }

    return false;

});

/*==================================================================*/
/*================== DISABLED JUSTIFICATIVA ========================*/
/*==================================================================*/

const disabledJustificativa = computed(() => {

    if(props.disabled){
        return true;
    }

    if(!props.aprovacao?.aprovador?.id){
        return true;
    }

    return false;

});

</script>

<template>

    <CartaoBase>

        <template #header>
            <span class="c-header__titulo">Aprovação</span>
        </template>

        <template #body>

            <div class="c-grid-aprovacao">

                <CampoTextoBase
                    label="Tipo de Aprovador"
                    :value="props.aprovacaoTipo"
                    disabled
                ></CampoTextoBase>

                <CampoAutocompleteBase
                    label="Aprovador"
                    item-text="codigo"
                    :items="props.aprovacoesDoTipo"
                    :value="props.aprovacao"
                    :disabled="disabledAprovador"
                    return-object
                    @change="selecionaAprovacao"
                >
            
                    <template #item="{ item }">
                        {{ item?.aprovador?.nome }}
                    </template>
                    <template #selection="{ item }">
                        {{ item?.aprovador?.nome }}
                    </template>
            
                </CampoAutocompleteBase>

                <CampoDataBase
                    label="Data da Decisão"
                    :value="props.aprovacao?.dataDecisao"
                    disabled
                ></CampoDataBase>

                <CampoTextareaBase
                    class="c-grid-aprovacao__justificativa"
                    label="Justificativa de Reprovação"
                    :value="props.aprovacao?.justificativa"
                    :disabled="disabledJustificativa"
                    @input="(valor) => alteraAprovacao({ justificativa: valor })"
                ></CampoTextareaBase>

            </div>

        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Header ========================================*/
/*==================================================================*/

.c-header__titulo {
    font-size: 1.25rem;
    font-weight: 700;
}

/*==================================================================*/
/*================== Grid Aprovação ================================*/
/*==================================================================*/

.c-grid-aprovacao {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.c-grid-aprovacao__justificativa {
    grid-column: 1 / -1;
}

@media (max-width: 960px) {
    .c-grid-aprovacao {
        grid-template-columns: 1fr;
    }
}

</style>
